import { render, staticRenderFns } from "./ProductFinishes.vue?vue&type=template&id=a61018f0"
import script from "./ProductFinishes.vue?vue&type=script&lang=js"
export * from "./ProductFinishes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports